// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__18j7k","buttons":"SendReceipts_buttons__3pPlu","email":"SendReceipts_email__1idOt","bookApptTitle":"SendReceipts_bookApptTitle__1Vvf-"};